import { useState } from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Receipt, BookOpen, Sparkles } from "lucide-react";
import { TDS_TABS } from "./tdsNavConfig";
import { TdsUserGuidePanel } from "./TdsUserGuide";
import { hasCompletedRegimeSelection, getSelectedOrgRegime } from "./tdsStorage";
import TdsWorkspaceGuard from "./TdsWorkspaceGuard";
import "./tds.css";

export default function TdsLayout() {
  const [guideOpen, setGuideOpen] = useState(false);
  const [guideSection, setGuideSection] = useState("overview");
  const location = useLocation();
  const isStartPage = location.pathname.endsWith("/start");
  const isGuidePage = location.pathname.endsWith("/guide");
  const showNav = !isStartPage && !isGuidePage && hasCompletedRegimeSelection();
  const regime = getSelectedOrgRegime();

  const openGuide = (section = "overview") => {
    setGuideSection(section);
    setGuideOpen(true);
  };

  return (
    <div className={`tds-root brix-page${isStartPage ? " tds-root--landing" : ""}`}>
      {showNav && (
        <>
          <header className="tds-hero">
            <div className="tds-hero-row">
              <div className="tds-hero-main">
                <div className="tds-hero-icon">
                  <Receipt size={22} strokeWidth={1.75} />
                </div>
                <div className="min-w-0">
                  <div className="tds-hero-eyebrow">
                    <Sparkles size={10} />
                    Statutory Setup
                  </div>
                  <h1 className="tds-hero-title">TDS — Tax Deducted at Source</h1>
                  <p className="tds-hero-sub">
                    Guided workflow for organization setup, employee tax, and compliance.
                  </p>
                </div>
              </div>
              <div className="tds-hero-actions">
                <button
                  type="button"
                  className="tds-btn tds-btn--guide"
                  onClick={() => openGuide("overview")}
                >
                  <BookOpen size={16} />
                  User Guide
                </button>
              </div>
            </div>
          </header>

          <nav className="tds-tabs" aria-label="TDS sections">
            {TDS_TABS.map((tab) => {
              const Icon = tab.icon;
              return (
                <NavLink
                  key={tab.id}
                  to={tab.path}
                  className={({ isActive }) =>
                    `tds-tab ${isActive ? "tds-tab--active" : ""}`.trim()
                  }
                >
                  <Icon size={15} strokeWidth={2} />
                  <span className="hidden sm:inline">{tab.label}</span>
                  <span className="sm:hidden">{tab.shortLabel}</span>
                </NavLink>
              );
            })}
          </nav>
        </>
      )}

      <TdsWorkspaceGuard>
        <Outlet context={{ openGuide, regime }} />
      </TdsWorkspaceGuard>

      <TdsUserGuidePanel
        open={guideOpen}
        onClose={() => setGuideOpen(false)}
        initialSection={guideSection}
        regime={regime}
      />
    </div>
  );
}
